import { useMutation } from 'react-query';
import { downloadRegisterResultDocxFile } from 'apis/registerResult.api';

const useDownloadRegisterResultDocxFile = () => useMutation(downloadRegisterResultDocxFile);

export default useDownloadRegisterResultDocxFile;
